// extracted by mini-css-extract-plugin
export default {"heading":"qs-z","corrected":"rs-z","redirectVerbiageContainer":"ss-z","redirectVerbiageText":"ts-z"};